
/*
  TITAN MODE – Zero-Scroll-Listener Motion Architecture
  - No window scroll listeners
  - Uses IntersectionObserver + sentinel probes
  - Infers scroll direction from entry.boundingClientRect.top deltas
  - Applies classes: body.motion-sticky, body.motion-header-hidden
*/
(function(){
  const headerWrap = document.querySelector('.shopify-section-main-header');
  if(!headerWrap) return;

  // Create sentinel elements
  const topSentinel = document.createElement('div');
  topSentinel.setAttribute('data-titan-sentinel','top');
  topSentinel.style.position = 'absolute';
  topSentinel.style.top = '0';
  topSentinel.style.left = '0';
  topSentinel.style.width = '1px';
  topSentinel.style.height = '1px';
  topSentinel.style.pointerEvents = 'none';

  const probe = document.createElement('div');
  probe.setAttribute('data-titan-sentinel','probe');
  probe.style.position = 'absolute';
  probe.style.top = '80px'; // Smart Sticky threshold // threshold for "sticky mode"
  probe.style.left = '0';
  probe.style.width = '1px';
  probe.style.height = '1px';
  probe.style.pointerEvents = 'none';

  // Insert at top of body so it scrolls with the page
  document.body.prepend(probe);
  document.body.prepend(topSentinel);

  // Sticky state observer (past threshold)
  const stickyObserver = new IntersectionObserver((entries)=>{
    const entry = entries[0];
    // If probe is NOT intersecting viewport, we scrolled past threshold
    document.body.classList.toggle('motion-sticky', !entry.isIntersecting);
    // When we're near the top, always show header
    if(entry.isIntersecting){
      document.body.classList.remove('motion-header-hidden');
    }
  }, { root: null, threshold: 0 });

  stickyObserver.observe(probe);

  // Direction inference observer
  let lastTop = null;
  let lastTime = performance.now();
  const dirObserver = new IntersectionObserver((entries)=>{
    const entry = entries[0];
    const nowTop = entry.boundingClientRect.top;
    const nowTime = performance.now();

    if(lastTop === null){
      lastTop = nowTop;
      lastTime = nowTime;
      return;
    }

    const dy = nowTop - lastTop; // positive when scrolling down? (probe moves down in viewport when scrolling up)
    const dt = Math.max(1, nowTime - lastTime);

    // When user scrolls DOWN the page, the probe's boundingClientRect.top decreases (moves up)
    const scrollingDown = dy < -0.5;
    const scrollingUp = dy > 0.5;

    // Only hide/show when we're in sticky mode (past threshold)
    if(document.body.classList.contains('motion-sticky')){
      if(scrollingDown){
        document.body.classList.add('motion-header-hidden');
      }else if(scrollingUp){
        document.body.classList.remove('motion-header-hidden');
      }
    }

    lastTop = nowTop;
    lastTime = nowTime;
  }, {
    root: null,
    // Make the observer fire more often by using multiple thresholds
    threshold: Array.from({length: 21}, (_,i)=> i/20)
  });

  dirObserver.observe(probe);

  // Cleanup hooks for Theme Editor
  function teardown(){
    try{ stickyObserver.disconnect(); }catch(e){}
    try{ dirObserver.disconnect(); }catch(e){}
    topSentinel.remove();
    probe.remove();
  }

  document.addEventListener('shopify:section:unload', (e)=>{
    // If header section is unloaded, teardown
    if(e && e.target && e.target.classList && e.target.classList.contains('shopify-section-main-header')){
      teardown();
    }
  });

})();
